
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  CssBaseline,
  TextField,
  Button,
  Grid,
  Typography,
  CircularProgress,
  Divider,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@mui/material";
import { signInWithGoogle, signInWithEmail, getCurrentUser } from "../../common/Authenticator";
import appLogo from "../../images/website-images/logos/app-logo.png";
import closeIcon from "../../images/website-images/icons/close-icon.png"; 
import googleIcon from "../../images/website-images/icons/google-icon.png";
import { useLocation } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import {db} from '../../firebaseConfig';

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const [openInvalidEmailAndPasswordDialog, setOpenInvalidEmailAndPasswordDialog] = useState(false);

  const [openAcountHasEmailPasswordLoginDialog, setOpenAcountHasEmailPasswordLoginDialog] = useState(false);

  const [openMustChangePasswordDialog, setOpenMustChangePasswordDialog] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

   // Get the page user tried to access before being redirected
   let from = location.state?.from?.pathname || "/app"; 
   const idParam = location.state?.id;

   useEffect(() => {
    const checkUser = async () => {
      const user = await getCurrentUser();
      
      if (user) {
        navigate(from, { replace: true });
      }
    };
    checkUser();
  }, [navigate, from]);


  const handleGoogleSignIn = async () => {
    /*
      if (!termsOfServiceChecked) {
        setOpenTermsDialog(true);
        return;
      }
      */
  
      setGoogleLoading(true);

      const signInResult = await signInWithGoogle(); 

      try
      {
        if (signInResult.user !== null && signInResult.user !== undefined)
        {
            if (signInResult.status === "already-has-password-login")
            {

              setOpenAcountHasEmailPasswordLoginDialog(true);

            } else
            {
                //navigate("/app");

                const uid = signInResult.user.uid;

                //Logic to set the testMode ----------------------------------
                const userDocRef = doc(db, "appUsers", uid);
                const userSnapshot = await getDoc(userDocRef);

                const userData = userSnapshot.data();

                const acctDocRef = doc(db, "appAccounts", userData.accountNumber);
                const acctSnapshot = await getDoc(acctDocRef);

                const acctData = acctSnapshot.data();

                if (acctData.subscriptionType === "paid")
                {
                    localStorage.setItem("testMode", "false");
                    
                } else 
                {
                    localStorage.setItem("testMode", "true");
                }
                //End Logic to set the testMode ----------------------------------

                if (idParam !== undefined && idParam !== null && idParam !=="")
                {
                  from = from + "?id=" + idParam;
                }

                navigate(from, { replace: true }); // Redirect back to intended page
            }
              
        }
      } catch(error)
      {
        setGoogleLoading(false);
      }
    };

   const handleEmailLogin = async (e, method) => {

    e.preventDefault();

    setLoading(true);

     try {
       const result = await method();

       let proceed= true;

       if (result != null && result.hasOwnProperty("emailSignInstatus")) // checks only for signin with email
       {
          if (result.emailSignInstatus !== "successfully-signed-in")
          {

            proceed= true;
          
            if (result.emailSignInstatus === "email-not-yet-verified")
            {

              proceed= false;
              
              setLoading(false);

              navigate("/signup?action=email-verification-required", { replace: true });

            } else if (result.emailSignInstatus === "invalid-email-password")
            {
              proceed= false;

              setOpenInvalidEmailAndPasswordDialog(true);

            }  else if (result.emailSignInstatus === "invalid-email-password")
              {
                proceed= false;
  
                setOpenInvalidEmailAndPasswordDialog(true);
  
              } else if (result.emailSignInstatus === "user-must-change-password")
              {
                proceed= false;
                
                setOpenMustChangePasswordDialog(true);
              }

          }
       }

       if (proceed)
       {
          const uid = result.user.uid;
              //Logic to set the testMode ----------------------------------
              const userDocRef = doc(db, "appUsers", uid);
              const userSnapshot = await getDoc(userDocRef);

              const userData = userSnapshot.data();

              const acctDocRef = doc(db, "appAccounts", userData.accountNumber);
              const acctSnapshot = await getDoc(acctDocRef);

              const acctData = acctSnapshot.data();

              if (acctData.subscriptionType === "paid")
              {
                  localStorage.setItem("testMode", "false");
                  
              } else 
              {
                  localStorage.setItem("testMode", "true");
              }
              //End Logic to set the testMode ----------------------------------

          setLoading(false);

          if (idParam !== undefined && idParam !== null && idParam !=="")
          {
            from = from + "?id=" + idParam;
          }
      
          navigate(from, { replace: true }); // Redirect back to intended page
       }

     } catch (error) {
       console.error("Login Error:", error);
     } finally {
      setLoading(false);
    }
   };

   const handleCloseInvalidEmailAndPasswordDialog = () => {
    setOpenInvalidEmailAndPasswordDialog(false);
  };

  return (

    <Container component="main" maxWidth="xs" sx={{ display: 'flex', justifyContent: 'center', marginTop:'40px' }}>
      
      <CssBaseline />

      <Box
        sx={{
          border: "1px solid #e0e0e0", // light gray border
          borderRadius: "12px",
          boxShadow: "3px 3px 12px #bfbfbf", // soft shadow
          paddingTop: 4,
          paddingBottom: 4,
          paddingLeft: { xs: 4, sm: 8 },
          paddingRight: { xs: 4, sm: 8 },
          backgroundColor: "#fff", // white background
          minWidth: { sm: '550px' }, // Only applies from 'sm' (600px) and up
        }}
      >
        <Box
          position="absolute"
          top={10}
          right={10}
          zIndex={10}
        >
          <a href="/">
            <img src={closeIcon} style={{ height: "30px" }} alt="close" />
          </a>
        </Box>
      

          <Box textAlign="center" pb={1}>
            <img
              src={appLogo}
              alt="App Logo"
              style={{ height: 85, cursor: "pointer" }}
              onClick={() => navigate("/")}
            />
            <Typography component="h1" variant="h6" fontWeight="600" mt={2}>
              Sign in to your Bakeryly account
            </Typography>
          </Box>

          <Box>
          <form onSubmit={(e) => handleEmailLogin(e, () => signInWithEmail(email, password))}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      label="Email"
                      fullWidth
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      error={!!errors.email}
                      helperText={errors.email}
                    />
                  </Grid>
     
                  <Grid item xs={12}>
                    <TextField
                      label="Password"
                      type="password"
                      fullWidth
                      required
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      error={!!errors.password}
                      helperText={errors.password}
                    />
                    
                    <div style={{float:'right'}}>
                        <Button
                              component="button"
                              onClick={() => navigate('/reset')}
                              sx={{
                                color: '#5f5fff',
                                fontSize: '14px',
                                textDecoration: 'none',
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                textTransform: 'none', // 👈 this line fixes the casing
                                '&:hover': {
                                  textDecoration: 'underline'
                                }
                              }}
                            >
                              Forgot your password?
                        </Button>
                    </div>

                  </Grid>

                </Grid>
                
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{
                    mt: 3,
                    backgroundColor: "#635bff",
                    fontWeight: "bold",
                    textTransform: "none",
                    fontSize: "18px",
                  }}
                  disabled={loading || googleLoading}
                >
                  {loading ? <CircularProgress size={24} color="inherit" /> : "Sign in"}
                </Button>

                </form>
              
              <br></br><br></br>
              <Box display="flex" alignItems="center" mb={2}>
                <Divider sx={{ flex: 1 }} />
                <Typography sx={{ mx: 2, color: "text.secondary" }}>OR</Typography>
                <Divider sx={{ flex: 1 }} />
              </Box>

              <Button
                fullWidth
                variant="outlined"
                onClick={(e) => handleGoogleSignIn()}
                sx={{
                  mt: 2,
                  mb: 2,
                  textTransform: "none",
                  fontWeight: "bold",
                  minHeight: '55px',
                  fontSize:'17px'
                }}
                disabled={loading || googleLoading}
              >
                <img
                  src={googleIcon}
                  alt="Google Icon"
                  style={{ width: 20, marginRight: 10 }}
                />
                
                {googleLoading ? <CircularProgress size={24} color="inherit" /> : "Sign in with Google"}
              </Button>

              <Box textAlign="center" mt={3}>
              <Typography variant="body2" sx={{ fontSize: '17px' }}>
                <Box 
                  component="a"
                  href="/signup"
                  sx={{
                    color: '#5f5fff',
                    textDecoration: 'none',
                    '&:hover': {
                      textDecoration: 'underline'
                    }
                  }}
                >
                  Don't have an account? <span style={{ fontWeight: "bold" }}>Sign Up</span>
                </Box>
            </Typography>

              </Box>
        </Box>



        <Dialog open={openInvalidEmailAndPasswordDialog} onClose={handleCloseInvalidEmailAndPasswordDialog}>
          <DialogTitle>Invalid Email/Password</DialogTitle>
          <DialogContent>
            <DialogContentText>
              The email and/or password you entered is invalid.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseInvalidEmailAndPasswordDialog} sx={{fontSize:'18px', fontWeight:'bold', border: "1px solid #8a8a8a", borderRadius: "12px", backgroundColor:'#f1f1f1'}} autoFocus>
              OK
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={openMustChangePasswordDialog} onClose={() => setOpenMustChangePasswordDialog(false)}>
          <DialogTitle>Password Must be Changed</DialogTitle>
          <DialogContent>
            <DialogContentText>
            <p>You are required to update your password. We've sent you an email with a link to reset it.</p>
            <p>If you don't see the email shortly, you can also use the 'Forgot your password?' link on this page to request a new one</p>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button 
            onClick={() => setOpenMustChangePasswordDialog(false)}
            sx={{fontSize:'18px', fontWeight:'bold', border: "1px solid #8a8a8a", borderRadius: "12px", backgroundColor:'#f1f1f1'}} autoFocus>
              OK
            </Button>
          </DialogActions>
        </Dialog>


        <Dialog open={openAcountHasEmailPasswordLoginDialog} onClose={() => setOpenAcountHasEmailPasswordLoginDialog(false)}>
          <DialogTitle>Email/Password Account Already Exists</DialogTitle>
          <DialogContent>
            <DialogContentText>
              This email is already registered with a password. Please sign in using your password or use the "Forgot your password?" link if you need to reset it.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button 
              onClick={() => setOpenAcountHasEmailPasswordLoginDialog(false)}
              sx={{fontSize:'18px', fontWeight:'bold', border: "1px solid #8a8a8a", borderRadius: "12px", backgroundColor:'#f1f1f1'}} autoFocus>
              OK
            </Button>
          </DialogActions>
        </Dialog>




        </Box>
    </Container>
  );
};

export default Login;
